import { render, staticRenderFns } from "./AgentLeaveList.vue?vue&type=template&id=868de58a&scoped=true"
import script from "./AgentLeaveList.vue?vue&type=script&lang=js"
export * from "./AgentLeaveList.vue?vue&type=script&lang=js"
import style0 from "./AgentLeaveList.vue?vue&type=style&index=0&id=868de58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868de58a",
  null
  
)

export default component.exports